"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _antDesignVue = require("ant-design-vue");
var _default = exports.default = {
  name: 'InputNumberRange',
  // 数字区间组件
  props: {
    ..._antDesignVue.InputNumber.props,
    value: {
      type: Array,
      default: () => {
        return [null, null];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: Array,
      default: () => {
        return ['最小值', '最大值'];
      }
    },
    // 数值精度
    precision: {
      type: Number,
      default: undefined
    }
  },
  watch: {
    value: {
      handler(val) {
        this.$emit('input', val);
      },
      immediate: true
    }
  },
  methods: {
    handleChange(value, key) {
      this.$emit('change', value, key);
      const [min, max] = this.value;
      if (value === '' || value === null) return;
      if (key === 'min' && max !== null && value > max) this.value[0] = max;
      if (key === 'max' && min !== null && value < min) this.value[1] = min;
    }
  }
};